export const SUB_CATEGORY_CONFIG = {
  SUB_CATEGORY_LIST: {
    endPoint: 'dropdowns/sub_categories',
    method: 'GET',
    baseUrlKey: 'inventoryApiUrl',
  },
} 